module.exports = __webpack_public_path__ + "static/media/Mimikyu_gaussian2.46149d32.png";